import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import logo from '../../images/logo.svg'
import facebook from '../../images/logo-facebook.svg'
import instagram from '../../images/logo-instagram.svg'
import linkedin from '../../images/logo-linkedin.svg'
import twitter from '../../images/logo-twitter-bird.svg'

const StyledHeader = styled.header`
  display: flex;
  justify-content: space-between;
  background: #fff;
  padding: 14px;
`

const SocialLinks = styled.div`
  display: flex;

  & > a {
    display: flex;
    height: 20px;
    width: 20px;
    margin-right: 28px;
  }

  @media only screen and (max-width: 600px) {
    display: none;
  }
`

const Logo = styled(Link)`
  text-decoration: none;
  display: flex;

  & img {
    height: 20px;
    margin-right: 14px;
  }

  & h1 {
    color: #424242;
    font-size: 18.5px;
    line-height: 24px;
    text-transform: uppercase;
    font-weight: 300;
  }

  @media only screen and (max-width: 600px) {
    & h1 {
      display: none;
    }
  }
`

export const Header = () =>
  <StyledHeader>
    <Logo to='/'>
      <img src={logo} alt='NVIDIA Research' />
      <h1>AI Playground</h1>
    </Logo>
    <SocialLinks>
      <a href='https://www.facebook.com/NVIDIA/'><img src={facebook} title='NVIDIA on Facebook' alt='NVIDIA on Facebook' /></a>
      <a href='https://www.instagram.com/nvidia/?hl=en'><img src={instagram} title='NVIDIA on Instagram' alt='NVIDIA on Instagram' /></a>
      <a href='https://www.linkedin.com/company/nvidia'><img src={linkedin} title='NVIDIA on LinkedIn' alt='NVIDIA on LinkedIn' /></a>
      <a href='http://twitter.com/nvidia'><img src={twitter} title='NVIDIA on Twitter' alt='NVIDIA on Twitter' /></a>
    </SocialLinks>
  </StyledHeader>



// WEBPACK FOOTER //
// ./src/components/Header/Header.js